import { render, staticRenderFns } from "./FrzLineStationWork.vue?vue&type=template&id=6b8fdb9a&scoped=true"
import script from "./FrzLineStationWork.vue?vue&type=script&lang=js"
export * from "./FrzLineStationWork.vue?vue&type=script&lang=js"
import style0 from "./FrzLineStationWork.vue?vue&type=style&index=0&id=6b8fdb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8fdb9a",
  null
  
)

export default component.exports